const house = [
    {
        path: '/house/label',
        name: 'label',
        component: () => import('@/view/house/label'),
    }
]
export default house